import "./Objectives.scss";
import AluminiDynamicPages from '../AluminiDynamicPages';
import aluminiPages from "../AluminiPages.json";

const Objectives = () => {

    const objectivesPage = aluminiPages.objectives[0];

    return (
        <section className="aluminiObjecitvesMainContainer">
            <AluminiDynamicPages
                title={objectivesPage.title}
                content={objectivesPage.content}
                title2 ={objectivesPage.title2}
            />
        </section>
    )
}

export default Objectives
